/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {
  SelectWrapper,
  InputDateWrapper,
  InputTextWrapper,
} from '../../../../../../components/UI/Form/Input'
import {Button, ButtonWrapper, DrawerReport} from '../../../../../../components/UI/Button'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {laundryBilling2Filter} from '../../../../schema/laundryReport'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {SelectOption} from '../../../../../../models/utility.model'
import {
  LaundryBillingHystory2Model,
  LaundryFilterReportLaundry2Model,
} from '../../../../features/laundryBilling/model/laundryBilling.model'
import {getLaundryServicesBillingReport, getLaundryBilling2ReportXLS} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {clearFields} from '../../../../../../util/functions'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import {donwloadFile} from '../../../../helpers/utilities'
import {useCamp} from '../../../../../central/hooks'
const downloadReportForType = {
  xlsx: getLaundryBilling2ReportXLS,
}

type TypeDownloadReport = keyof typeof downloadReportForType
const TableLaundryBilling: FC = () => {
  const {isAllowed} = useLavanderia()
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {statusLaundry, getStatusLaundryList, getTypeLaundryOrderList, typeLaundryOrder} =
    useTableForMaster()
  const methods = useForm<LaundryFilterReportLaundry2Model>({
    resolver: yupResolver(laundryBilling2Filter),
  })
  const [valueForm, setValueForm] = useState<any>(null)
  const {setValue, handleSubmit, reset, setError} = methods
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const [camp, setCamps] = useState<SelectOption[]>([])

  const {getCampFD} = useCamp()

  const {
    company,
    client,
    site,

    getCompanyList,
    getClientList,
    getSiteList,
    handleClearList,
  } = useLaundryFilter()

  const getCampList = async (siteId: string) => {
    const data = await getCampFD({siteId: siteId})
    if (data.length === 1) {
      setValue('campamentoId', data[0].value as string)
      setError('campamentoId', {})
    }
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    clearFields(setValue as any, setError as any, {
      cliente: '',
      clienteId: '',
      siteId: '',
      site: '',
      campamentoId: '',
      campamento: '',
    })
  }
  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    clearFields(setValue as any, setError as any, {
      siteId: '',
      site: '',
      campamentoId: '',
      campamento: '',
    })
  }
  const handleFilterCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    clearFields(setValue as any, setError as any, {
      campamentoId: '',
      campamento: '',
    })
  }
  const getLaundryList = async () => {
    setLoading(true)
    try {
      const response = await getLaundryServicesBillingReport(valueForm, pagination.currentPage)
      const dataInfo = response.data?.data || []
      const dataProcess = groupByOrden(dataInfo)
      setData(dataProcess)
      setPagination({
        ...pagination,
        totalResults: response.data.total,
      })
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const groupByOrden = (datos: any) => {
    const contador: {[key: string]: number} = {}
    return datos.map((item: any) => {
      const clave = `${item.NroOrden}-${item.NroBoleta}`
      if (!contador[clave]) {
        contador[clave] = 0
      }
      contador[clave]++
      item.item = contador[clave].toString()
      return item
    })
  }

  const columns: Column<LaundryBillingHystory2Model>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de proceso' />,
        accessor: 'Servicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Punto de lavandería' />,
        accessor: 'Nombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de huésped' />,
        accessor: 'tipoHuesped',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro Orden de lavado' />,
        accessor: 'NroOrden',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro Boleta' />,
        accessor: 'NroBoleta',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro Documento huésped' />,
        accessor: 'DNI',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fotocheck' />,
        accessor: 'fotocheck',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='RUC' />,
        accessor: 'ruc',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nombre Empresa' />,
        accessor: 'empresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Administración' />,
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Item' />,
        accessor: 'item',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Ropa' />,
        accessor: 'tipoRopa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
        accessor: 'cantidad',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
        accessor: 'peso',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de servicio' />,
        accessor: 'tipoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cant Orden de lavado' />,
        accessor: 'cantidadOrdenLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cant Bolsas' />,
        accessor: 'cantidadBolsas',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso Total' />,
        accessor: 'pesoTotal',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Costo' />,
        accessor: 'costo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de recepción' />,
        accessor: 'fechaRecepcion',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaRecepcion)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaRecepcion)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Programada de Devolución al Huésped' />
        ),
        accessor: 'fechaProgramada',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaProgramada)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaProgramada)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Entrega Proveedor(proveedor)/ Fecha de Inicio Real de Lavado(compañía)'
            size='140px'
          />
        ),
        accessor: 'fechaEnvio',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaEnvio)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaEnvio)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Programada de Devolución por el Proveedor'
          />
        ),
        accessor: 'fechaProgramadaDevolucionProveedor',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaProgramadaDevolucionProveedor)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaProgramadaDevolucionProveedor)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de Devolución Real(proveedor)/ Fecha Fin real de Lavado(compañía)'
          />
        ),
        accessor: 'fechaRealDevolucion',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaRealDevolucion)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaRealDevolucion)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de Salida de Devolución al Huésped' />
        ),
        accessor: 'fechaSalidaDevolucionHuesped',
        Cell: ({...props}) => {
          return (
            <span>
              {formatDateDDMMYYYY(props.data[props.row.index].fechaSalidaDevolucionHuesped)
                ? formatDateDDMMYYYY(props.data[props.row.index].fechaSalidaDevolucionHuesped)
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Diferencia de Días entre la Fecha Programada de Devolución al Huesped - Fecha de Devolución Real o Fecha Fin Real de Lavado'
          />
        ),
        accessor: 'diferenciaDeDias',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cantidad de Días en Proceso de Lavado' />
        ),
        accessor: 'cantidadDiasenProceso',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad de Días Final hasta el Termino de Lavado'
          />
        ),
        accessor: 'cantidadDiasFinal',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado de la orden' />,
        accessor: 'statusOrdenLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Proveedor' />,
        accessor: 'proveedor',
      },
    ],
    [],
  )

  const onSubmit = (dataForm: LaundryFilterReportLaundry2Model) => {
    setValueForm(null)
    const {fechaRecepcionInicio, fechaRecepcionFin, fechaDevolucionInicio, fechaDevolucionFin} =
      dataForm
    setValueForm({
      fechaRecepcionInicio: fechaRecepcionInicio ? new Date(fechaRecepcionInicio) : '',
      fechaRecepcionFin: fechaRecepcionFin ? new Date(fechaRecepcionFin) : '',
      fechaDevolucionInicio: fechaDevolucionInicio ? new Date(fechaDevolucionInicio) : '',
      fechaDevolucionFin: fechaDevolucionFin ? new Date(fechaDevolucionFin) : '',
      ...dataForm,
    })
  }

  const handleResetForm = (): void => {
    setData([])
    reset()
    handleClearList()
    getCompanyList()
  }

  useEffect(() => {
    if (pagination.currentPage > 1) {
      getLaundryList()
    }
  }, [pagination.currentPage])

  useEffect(() => {
    if (valueForm) {
      getLaundryList()
    }
  }, [valueForm])

  useEffect(() => {
    if((company?? []).length > 0) {
      setValue('companiaId', company[0].value as string)
      setError('companiaId', {})
    }
  }, [company])

  useEffect(() => {
    getStatusLaundryList()
    getCompanyList()
    getTypeLaundryOrderList()
  }, [])

  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    try {
      setIsDownload(true)
      const response = await downloadReportForType[typeFormat](valueForm)
      await donwloadFile(response.data, typeFormat)
      setIsDownload(false)
    } catch (error) {
      setIsDownload(false)
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('FILTRO') && (
          <div className='p-8'>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Compañía'
                      name='companiaId'
                      data={company}
                      onChangeValue={handleFilterClient}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Cliente'
                      name='clienteId'
                      data={client}
                      disabled={client.length === 0}
                      onChangeValue={handleFilterSite}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Site'
                      name='siteId'
                      data={site}
                      disabled={site.length === 0}
                      onChangeValue={handleFilterCamp}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Campamento'
                      name='campamentoId'
                      data={camp}
                      disabled={camp.length === 0}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputTextWrapper
                      labelText='Nro de Boleta'
                      name='nroBoleta'
                      type='ticketNumber'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper
                      labelText='Fecha Recepción Inicial'
                      name='fechaRecepcionInicio'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper labelText='Fecha Recepción Final' name='fechaRecepcionFin' />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper
                      labelText='Fecha Devolución Inicial'
                      name='fechaDevolucionInicio'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper
                      labelText='Fecha Devolución Final_'
                      name='fechaDevolucionFin'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Estado'
                      name='statusOrdenLavado'
                      data={statusLaundry}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Tipo de Servicio'
                      name='tipoServicio'
                      data={typeLaundryOrder}
                    />
                  </div>
                  {/* <div className='col-sm-12 col-lg-3'>
                    <div>
                      <label>Incluir:</label>
                      <div className='row' style={{padding: '8px 16px 8px 0'}}>
                        <div className='col-sm-12 col-lg-6'>
                          <label className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              value='1'
                              defaultChecked={true}
                            />
                            <span className='form-check-label'>Cliente</span>
                          </label>
                        </div>
                        <div className='col-sm-12 col-lg-6'>
                          <label className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              value='1'
                              defaultChecked={true}
                            />
                            <span className='form-check-label'>Compañia</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                  <Button label='Buscar' typeBtn='submit' />
                  <Button label='Limpiar' onClick={() => handleResetForm()} />

                  {valueForm && (
                    <Button label='Descargar' onClick={() => handleDownloadReport('xlsx')} />
                  )}
                </ButtonWrapper>
              </form>
            </FormProvider>
          </div>
        )}
        {isAllowed('REPORTE') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable<LaundryBillingHystory2Model> data={data} columns={columns} />
          </>
        )}
        <div className='row ms-8 my-2'>
          <div className='col-4'>
            <p className='fs-9 text-style-italic mb-0'>
              FÓRMULA PARA DIFERENCIA INICIO DE LAVADO: F.C. - F.P. ó F.E. - F.P.
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FE: Fecha de envío (viene de la ventana PROCESO DE LAVADO cuando se
              INICIA LAVADO, se toma de los campos FECHA DE INCIO REAL cuando TIPO DE ADMINISTRACIÓN
              es COMPAÑÍA y FECHA DE ENTREGA A PROVEEDOR cuando TIPO DE ADMISNITRACIÓN es PROVEEDOR
              )
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FC: Fecha de consulta (se tomará esta fecha cuando no se haya
              INICIADO EL LAVADO)
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FP: Fecha programada (viene de la ventana RECEPCIÓN)
            </p>
          </div>
          <div className='col-4'>
            <p className='fs-9 text-style-italic mb-0'>
              FÓRMULA PARA CANT DIAS DE PROCESO: F.C. - F.E. ó F.D.R. - F.E.
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FC: Fecha de consulta (se tomará esta fecha cuando no se haya
              FINALIZADO EL LAVADO)
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FDR: Fecha de devolución real (viene de la ventana de PROCESO DE
              LAVADO cuando TIPO DE ADMINISTRACIÓN es EXTERNO)
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FE: Fecha Envío (viene de la ventana PROCESO DE LAVADO, se toma de
              los campos FECHA DE INCIO REAL cuando TIPO DE ADMINISTRACIÓN es COMPAÑÍA y FECHA DE
              ENTREGA A PROVEEDOR cuando TIPO DE ADMISNITRACIÓN es PROVEEDOR)
            </p>
          </div>
          <div className='col-4'>
            <p className='fs-9 text-style-italic mb-0'>
              FÓRMULA PARA CANT. DE DIAS FINAL: F.R. - F.D.R. ó F.R. - F.F.R.
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FR: Fecha de rececpción (viene de la ventana RECEPCIÓN)
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FDR: Fecha de devolución real (viene de la ventana de PROCESO DE
              LAVADO cuando TIPO DE ADMINISTRACIÓN es PROVEEDOR)
            </p>
            <p className='fs-9 text-style-italic mb-0'>
              <strong>*</strong>FFR: Fecha Fin Real de Lavado (viene de la ventana de PROCESO DE
              LAVADO cuando TIPO DE ADMINISTRACION es COMPAÑÍA)
            </p>
          </div>
        </div>
      </KTCard>
    </>
  )
}

const TableLaundryBilling2Wrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryBilling />
    </KTableProvider>
  )
}

export {TableLaundryBilling2Wrapper}
